export const inputCls =
  "bg-[#F8FAFC] border-[#D0E2FF] text-[#0F172A] placeholder:text-[#94A3B8] focus-visible:border-[#60A5FA] focus-visible:ring-2 focus-visible:ring-[#D0E2FF] focus-visible:bg-white transition-colors";

export const btnPrimary =
  "bg-[#60A5FA] hover:bg-[#2563EB] text-white hover:text-white transition-colors duration-300 font-medium shadow-sm hover:shadow-md active:scale-[0.98] focus-visible:ring-2 focus-visible:ring-[#A6C8FF] focus-visible:ring-offset-2";

export const btnGhost =
  "border-[#D0E2FF] text-[#1E40AF] hover:bg-[#F0F6FF] hover:border-[#A6C8FF] transition-colors active:scale-[0.98]";

export const labelCls =
  "text-xs font-semibold tracking-[0.05em] uppercase text-[#64748B]";
